<template>
  <b-container fluid>
    <h1>Trainer and Regional Coordinator Performance</h1>
    <div v-if="loaded">
      <mio-filters label="Select country:" :options="TrainerCoordinatorPerformanceData.filters" />
      <div v-for="section in TrainerCoordinatorPerformanceData.sections" :data-filter="section.title">
        <h2>{{ section.title }}</h2>
        <mio-output v-for="output, index in section.outputs" :key="index"
          :title="output.title"
          :tables="output.tables"
        />
      </div>
    </div>
    <h2 v-else>Loading...</h2>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import MioFilters from '@/components/MioFilters';
import MioOutput from '@/components/MioOutput';

export default {
  name: 'MioTrainerCoordinatorPerformance',
  components: {
    MioFilters,
    MioOutput,
  },
  data() {
    return {
      loaded: false,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
       GET_TRAINER_COORDINATOR_PERFORMANCE: "mio/GET_TRAINER_COORDINATOR_PERFORMANCE",
    }),
    async getData() {
      try {
        await this.GET_TRAINER_COORDINATOR_PERFORMANCE();

        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    TrainerCoordinatorPerformanceData: {
      get() {
        let working = this.$store.state.mio.trainerCoordinatorPerformance;

        let output = {
          sections: [],
          method: "",
          messages: [],
        };
        const cols = {
          groups: 'groups',
          teachers: 'teachers',
          schools: 'schools',
          modulesDelivered: 'modules',
          supportGroups: 'support groups',
          moduleVisits: 'module visits',
          maintenanceVisits: 'maintenance visits',
          covisits: 'covisits'
        };

        // Format for output
        output.sections = Object.keys(working.coordinators).map(country => ({
          title: country,
          outputs: Object.keys(working.coordinators[country]).map(coordinatorID => ({
            tables: [
              {
                firstRowHeader: 'Coordinator',
                classes: 'bg-grey-light mb-0 font-weight-bold',
                cols: Object.values(cols),
                rows: [{
                  title: working.coordinators[country][coordinatorID],
                  subRows: working.data[coordinatorID] && Object.keys(working.data[coordinatorID].data).sort().reverse().map(year => ({
                    title: year,
                    data: Object.keys(cols).map(col => working.data[coordinatorID].data[year][col]),
                  })),
                }],
              },
              {
                firstRowHeader: 'Trainers',
                cols: Object.values(cols),
                rows: working.data[coordinatorID] && Object.keys(working.data[coordinatorID].trainers).map(trainerID => ({
                  title: working.trainers[trainerID],
                  subRows: Object.keys(working.data[coordinatorID].trainers[trainerID].data).sort().reverse().map(year => ({
                    title: year,
                    data: Object.keys(cols).map(col => working.data[coordinatorID].trainers[trainerID].data[year][col]),
                  })),
                }))
              },
            ]
          }))
        }));

        // Add country filters
        output.filters = Object.keys(working.coordinators).sort();

        // console.log(working);
        // console.log(output);
        return output;
      }
    }
  },
};
</script>
